import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ConfirmationRequestFormBase } from '@bo-client/shared/base-components/confirmation-request-form.base';
import { Subject } from 'rxjs';
import { AuthenticationService } from '@bo-client/core';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { ErrorsFormsService } from '@bo-client/shared/form-errors/errors-forms.service';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { CreateFormsService } from '@bo-client/activation-management/shared/forms/create-forms.service';

@Component({
  selector: 'app-gr-assign-technician-confirmation-form',
  templateUrl: './gr-assign-technician-confirmation-form.component.html',
  styleUrls: ['./gr-assign-technician-confirmation-form.component.scss']
})
export class GrAssignTechnicianConfirmationFormComponent
  extends ConfirmationRequestFormBase<GridRegistrationModel>
  implements OnInit, OnDestroy
{
  @Output() onErrorsChanged = new EventEmitter<any>();
  public compUnsubs$ = new Subject<void>();
  private gridRegistrationDto: GridRegistrationModel;

  public constructor(
    protected authenticationService: AuthenticationService,
    protected dataShareService: DataShareService,
    protected errorsFormsService: ErrorsFormsService,
    protected createFormsService: CreateFormsService
  ) {
    super(authenticationService, dataShareService, errorsFormsService);
  }

  ngOnInit(): void {}

  loadFormWithModel(result: GridRegistrationModel) {
    this.gridRegistrationDto = result;
    this.formGroup = this.createFormsService.formConfirmation();
  }

  hookErrors() {
    // entry Point to check specific errors
    console.log('emitting errors', this.errorFormList);
    this.onErrorsChanged.emit(this.errorFormList);
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
